import React from "react"
import { graphql } from "gatsby";
import Layout from "../components/layout"
import OpenDayList from "../components/open-day-list"

export default function OpenDays ({data}) {

    const html = data.markdownRemark.html;

    return (
        <Layout>
            <h1>Open Days</h1>
            <OpenDayList/>
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </Layout>
    );
}

export const pageQuery = graphql`
    query {
        markdownRemark(frontmatter: {type: {eq: "page"}, page: {eq: "open-days"}}) {
            html
        }
    }
`;